import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import bookingDE from 'locals/booking_DE.json'
import bookingEN from 'locals/booking_EN.json'
import LanguageDetector from 'i18next-browser-languagedetector'

const resources = {
  en: {
    translation: bookingEN,
  },
  de: {
    translation: bookingDE,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'de',
    returnNull: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
